/* ============================================================
   REVIVA — Scheda rapida (quick view)
   Intercetta il clic sulle card, carica il contenuto prodotto via
   Section Rendering API e lo mostra in una modale (bottom sheet su mobile).
   ============================================================ */
(function () {
  'use strict';

  var overlay = document.querySelector('[data-qv-overlay]');
  if (!overlay) return;
  var content = overlay.querySelector('[data-qv-content]');
  var spinner = overlay.querySelector('[data-qv-spinner]');
  var lastFocus = null;

  function lockScroll(on) {
    var de = document.documentElement;
    if (on) {
      // Compensa la larghezza della scrollbar per evitare lo spostamento della pagina
      var sw = window.innerWidth - de.clientWidth;
      de.style.overflow = 'hidden';
      if (sw > 0) de.style.paddingRight = sw + 'px';
    } else {
      de.style.overflow = '';
      de.style.paddingRight = '';
    }
  }

  function openOverlay() {
    overlay.hidden = false;
    // forza reflow per la transizione
    void overlay.offsetWidth;
    overlay.classList.add('is-open');
    lockScroll(true);
  }

  function closeOverlay() {
    overlay.classList.remove('is-open');
    lockScroll(false);
    var onEnd = function () {
      overlay.hidden = true;
      content.innerHTML = '';
      overlay.removeEventListener('transitionend', onEnd);
    };
    overlay.addEventListener('transitionend', onEnd);
    // fallback nel caso transitionend non scatti
    setTimeout(function () { if (!overlay.classList.contains('is-open')) { overlay.hidden = true; } }, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function showSpinner(on) {
    if (spinner) spinner.style.display = on ? 'block' : 'none';
  }

  var isLoading = false;

  // Espone l'apertura della scheda rapida ad altri script (es. striscia "In rotazione")
  window.RevivaQuickView = {
    open: function (url) { if (url) loadQuickView(url); }
  };

  function loadQuickView(url) {
    if (isLoading) return;
    isLoading = true;
    lastFocus = document.activeElement;
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    fetch(url + sep + 'section_id=reviva-quick-view', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        // Inietta il contenuto PRIMA di aprire: la finestra appare già alla misura
        // giusta, senza salti/glitch.
        content.innerHTML = html;
        openOverlay();
        var closeBtn = content.querySelector('[data-qv-close]');
        if (closeBtn) closeBtn.focus();
      })
      .catch(function () {
        // in caso di errore, vai alla pagina prodotto
        window.location.href = url;
      })
      .finally(function () {
        isLoading = false;
      });
  }

  // --- Apertura al clic sulla card (mantiene href come fallback) ---
  document.addEventListener('click', function (e) {
    // ignora se un trascinamento della striscia è appena avvenuto
    if (window.__stripJustDragged && (Date.now() - window.__stripJustDragged) < 350) return;
    // rispetta ctrl/cmd/click centrale per aprire in nuova scheda
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var card = e.target.closest('.reviva-card, [data-quick-view]');
    if (!card) return;
    var url = card.getAttribute('data-product-url') || card.getAttribute('href');
    if (!url) return;
    e.preventDefault();
    loadQuickView(url);
  });

  // --- Chiusura ---
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay || e.target.closest('[data-qv-close]')) {
      closeOverlay();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeOverlay();
  });

  // --- Aggiungi al carrello (AJAX) dentro la scheda, con apertura del drawer ---
  overlay.addEventListener('submit', function (e) {
    var form = e.target.closest('.reviva-qv__form');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Aggiunta…'; }

    // Raccogli le sezioni del carrello da aggiornare (come fa il form nativo di Horizon)
    var sectionIds = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && sectionIds.indexOf(id) === -1) sectionIds.push(id);
    });

    var data = new FormData(form);
    if (sectionIds.length) data.append('sections', sectionIds.join(','));

    fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: data })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        return r.json();
      })
      .then(function (added) {
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          // Emette l'evento nativo di Horizon per ri-renderizzare il carrello
          var ev = new Event('cart:update', { bubbles: true });
          ev.detail = {
            resource: cart,
            sourceId: 'reviva-quick-view',
            data: {
              source: 'reviva-quick-view',
              sections: added.sections,
              itemCount: cart.item_count
            }
          };
          document.dispatchEvent(ev);

          closeOverlay();

          var drawer = document.querySelector('cart-drawer-component');
          var dialog = drawer && drawer.querySelector('dialog.cart-drawer__dialog');
          // Prova il metodo nativo di Horizon; se non apre, forza showModal
          try { if (drawer && typeof drawer.open === 'function') drawer.open(); } catch (e) {}
          setTimeout(function () {
            if (dialog && !dialog.open) {
              try { dialog.showModal(); } catch (e) {}
            } else if (!dialog) {
              window.location.href = '/cart';
            }
          }, 90);
        });
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = original; }
        alert('Non è stato possibile aggiungere il prodotto. Riprova.');
      });
  });
})();
